var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurrentTime = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.967 6.667 2.033 2 2.034-2h3.3A.667.667 0 0 0 14 6V4a.667.667 0 0 0-.667-.667H2.667A.667.667 0 0 0 2 4v2c0 .368.299.667.667.667h3.3ZM.667 4a2 2 0 0 1 2-2h10.666a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2.666l-2 1.785v3.548a.667.667 0 1 1-1.334 0V9.785L5.333 8H2.667a2 2 0 0 1-2-2V4Z",
  clipRule: "evenodd"
})));
SvgCurrentTime.viewBox = '0 0 16 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurrentTime);
export default ForwardRef;